import React, { Component, Fragment } from 'react';
import { Logging, CustomLoading } from './LoadingComponent';
import { connect } from 'react-redux';
import { Breadcrumb, BreadcrumbItem, Label, Input, Button, ButtonGroup, Alert, Collapse } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { aggregate, sort_by, CustomListSelect, array_groupby } from './Functions';
import { RenderTable, RenderVirtualTable } from './TableComponent';
import { PiePlot, MultBarPlot, BarPlot, MultLineTsPlot } from './PlotComponent';
import { postRequest } from '../redux/ActionCreators';


// import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm,
    client_portfolio: state.client_portfolio,
    client_port_exposure: state.client_port_exposure,
    client_port_metrics: state.client_port_metrics,
    client_port_backtest: state.client_port_backtest,
    client_params: state.client_params,
  };
};

class ClientPortSuitability extends Component {
  constructor(props){
      super(props);
      this.state = {
        loading_portfolio:false,
        loading_backtest:false,
        port_id:'Portafolio',
        show_fx:true,
        show_assets_w:false,
        msg:null,
        msg_backtest:null,
        tra_agg:true
      };
      this.loadPortfolio = this.loadPortfolio.bind(this);
      this.header = this.header.bind(this);
  }
  
  async loadPortfolio(){
    if (this.props.client_params.port_name=='' || this.props.client_params.port_name==null) {
      this.setState({msg:"Seleccionar portafolio!"});
    } else if (this.props.client_portfolio==null) {
      this.setState({msg:"Cargar portafolio del cliente!"});
    } else if (this.props.client_params.bench_name==null) {
      this.setState({msg:"Seleccionar Benchmark!"});
    } else {
      this.setState({msg:null});
      this.setState({loading_portfolio:true});
      console.log(this.props.user_wm.data.client_ports.filter(x=>x.clientId==this.props.client_params.port_name)[0].portId || this.props.client_params.bench_name);
      // Exposure
      try {
        const client_port_exp = await postRequest(
          { 
            port:this.props.client_portfolio.port.map(item=>{
              return {isin:item.isin, name:item.assetName, value:item.mktValue};
            }), 
            bench:this.props.user_wm.data.client_ports.filter(x=>x.clientId==this.props.client_params.port_name)[0].portId || this.props.client_params.bench_name,
            use_assets_bench:this.props.client_params.assets_bench
          }, 'port_exposure_wm');
        await this.props.changeModel('client_port_exposure', client_port_exp);
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          msg_exp: error.message
        });
      }

      // Metrics
      try {
        const client_port_metrics = await postRequest(
          { 
            port:this.props.client_params.risk_type=="ex_ante" ? this.props.client_portfolio.port.map(item=>{
              const entry = {name:item.assetName, value:item.mktValue};
              if (item.benchmark !== undefined) {
                entry.benchmark = item.benchmark;
              }
                return entry;
              }) : null,
            bench:this.props.user_wm.data.client_ports.filter(x=>x.clientId==this.props.client_params.port_name)[0].portId || this.props.client_params.bench_name,
            client_id:this.props.client_params.risk_type=="ex_ante" ? null : this.props.client_params.port_name, 
            client_cty:this.props.user_wm.data.client_ports.filter(x=>x.clientId==this.props.client_params.port_name)[0].cty,
            ref_curr:this.props.client_params.fx,
            ini_date:this.props.client_params.metrics_date,
            use_assets_bench:this.props.client_params.assets_bench
          }, 'port_metrics_wm');
        await this.props.changeModel('client_port_metrics', {...client_port_metrics, risk_type:this.props.client_params.risk_type});
      } catch (error) {
        console.error('Error getting response:', error);
        this.setState({
          msg: error.message
        });
      }
      this.setState({
        loading_portfolio:false,
      });
      
      // Performance
      try {
        this.setState({loading_backtest:true})
        const client_port_backtest = await postRequest(
          { 
            port_weights:this.props.client_portfolio.port.map(item=>{
              return {name:item.assetName, w:item.weight/100}
              }),
            bench_name:this.props.user_wm.data.client_ports.filter(x=>x.clientId==this.props.client_params.port_name)[0].portId || this.props.client_params.bench_name,
            ref_curr:this.props.client_params.fx,
            ini_date:this.props.client_params.metrics_date,
            assets_funds_map:null
          }, 'port_backtest');
          
        await this.props.changeModel('client_port_backtest', Object.fromEntries(["status","tr_contrib", "tra_asset", "risk_contrib"].map(key => [key, client_port_backtest[key]])));
        this.setState({loading_backtest:false});
      } catch (error) {
        await this.props.changeModel('client_port_backtest', null);
        console.error('Error getting response:', error);
        this.setState({loading_backtest:false})
        this.setState({
          msg_backtest: error.message
        });
      }


    }
  }

  header(){
    return(
      <>
        <div className="row mt-5 justify-content-center">
          <div className="col-auto">
            <h4>Análisis de Portafolio</h4>
          </div>
        </div>
        <div className="row m-3 justify-content-center">
          <div className="col-auto">
            <Breadcrumb>
              <BreadcrumbItem><Link to='/client_portfolio/stage/check'>Chequeo del Portafolio</Link></BreadcrumbItem>
              <BreadcrumbItem><Link to='/client_portfolio/stage/metrics'>Evaluación de Riesgo</Link></BreadcrumbItem>
              <BreadcrumbItem active>Alineación de Estrategia de Inversión</BreadcrumbItem>
              <BreadcrumbItem><Link to='/client_portfolio/stage/adjust'>Ajuste de Portafolio</Link></BreadcrumbItem>
            </Breadcrumb>
          </div>
        </div>
        <div className="row m-3 justify-content-center align-items-center">
          <div className='col-md-3'>
            {this.props.user_wm.data.client_ports.filter(x=>x.clientId==this.props.client_params.port_name)[0]?.portId ? 
            <>
             <h6>cliente Perfil {this.props.user_wm.data.client_ports.filter(x=>x.clientId==this.props.client_params.port_name)[0].profile}</h6> 
             <p>({this.props.user_wm.data.client_ports.filter(x=>x.clientId==this.props.client_params.port_name)[0].portId || this.props.client_params.bench_name})</p>
            </>
            :<CustomListSelect
              maxMenuHeight={150}
              options={this.props.user_wm.data.ports_list.map(x=>{
                return {value:x, label:x};
              })}
              isClearable={true}
              value={this.props.client_params.bench_name==null ? null : {value:this.props.client_params.bench_name, label:this.props.client_params.bench_name}}
              onChange={(e)=>this.props.changeModel("client_params.bench_name", e==null ? null : e.value)}
              itemSize={50}
              className="basic-single"
              placeholder="seleccionar benchmark"
            />
            }
          </div>
          <div className='col-md-3'>
            <Button 
              className="btn-corp"
              onClick={this.loadPortfolio}
            >
              Actualizar Métricas
            </Button>
          </div>
        </div>
        <div className="row m-4 justify-content-center">
          <div className='col'>
            <ButtonGroup size='sm'>
              <Button
                color="dark"
                outline
                onClick={() => this.props.changeModel('client_params.risk_type', 'ex_ante')}
                active={this.props.client_params.risk_type=='ex_ante'}
              >
                Riesgo Actual
              </Button>
              <Button
                color="dark"
                outline
                onClick={() => this.props.changeModel('client_params.risk_type', 'ex_post')}
                active={this.props.client_params.risk_type=='ex_post'}
              >
                Riesgo realizado
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div className="row mt-4 justify-content-center">
          <div className="col-6 m-3">
            <Alert
              color={this.state.msg!==null && this.state.msg.includes('Error') ? 'danger':'secondary'}
              isOpen={this.state.msg!=='' && this.state.msg!==null} 
              toggle={()=>this.setState({msg:null})}>
                {this.state.msg}
            </Alert>
          </div>
        </div>
        
      </>
      );
  }

  render() {
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Logging />
            </div>
          </div>
        );
      } else if (this.state.loading_portfolio){
          return(
            <div className='container'>
              {this.header()}
              <div className="row justify-content-center m-5">
                <CustomLoading msg="calculando métricas" icon="fa-calculator" />
              </div>
            </div>
          );
      } else if (this.props.client_portfolio==null){
          return(
            <div className='container'>
              {this.header()}
              <div className="row justify-content-center m-5">
                  <p>No hay datos disponibles.</p>
              </div>
            </div>
          );
      } else {
        let port_assetclass_exp = this.props.client_port_exposure==null ? null  
          : this.props.client_port_exposure.names.length==1 ? null
          : aggregate(this.props.client_port_exposure.w_ac, ['AssetClass'], ['Portafolio', 'Benchmark']).sort(sort_by('value'));
        
        const port_w = this.props.client_port_exposure==null ? null
          : this.props.client_port_exposure.w_assets.filter(x=>x.Portafolio>0).map(item=>{
            return {name:item.name, w:item.Portafolio};
          });
        const bench_w = this.props.client_port_exposure==null || this.props.client_port_exposure.names.length==1 ? null
          : this.props.client_port_exposure.w_assets.filter(x=>x.Benchmark>0).map(item=>{
            return {name:item.name, w:item.Benchmark};
          });
        let port_curr_exp = this.props.client_port_exposure==null ? null
                            : this.props.client_port_exposure.names.length==1 ? null
                            : aggregate(this.props.client_port_exposure.w_ac, ['Currency'], ['Portafolio', 'Benchmark']).sort(sort_by('value'));
        const real_rets = this.props.client_port_metrics==null || this.props.client_port_metrics.names.length==1 ? null
                          : this.props.client_port_metrics.real_rets;
    
        const rets_summ = this.props.client_port_metrics==null ? null
                          : this.props.client_port_metrics.names.length==1 ? null
                          : this.props.client_port_metrics.rets_summ.map(({Métrica, Portafolio, Benchmark}) => ({Métrica, Portafolio, Benchmark}));;
    
        const series = this.props.client_port_metrics==null || this.props.client_port_metrics.names.length==1 ? null : this.props.client_port_metrics.series;

        const tra_asset = this.props.client_port_backtest==null || this.props.client_port_backtest.status!=='ok' ? null :
                          this.state.tra_agg ?
                          aggregate(this.props.client_port_backtest.tra_asset, ['Clase de Activo'], Object.keys(this.props.client_port_backtest.tra_asset[0]).filter(k=>!['Activo', 'Clase de Activo'].includes(k))).sort(sort_by('Portafolio')) :
                          this.props.client_port_backtest.tra_asset.map(({['Clase de Activo']: _, ...rest }) => rest);
        return (
          <div className="container">
            {this.header()}
            {bench_w!==null ?
            <>
              <Button className='link-btn' onClick={()=>this.setState({show_assets_w:!this.state.show_assets_w})}>
                ver portafolios &#8659;
              </Button>
              <Collapse isOpen={this.state.show_assets_w}>
                <div className="row m-5 justify-content-center">
                  <div className='col'>
                    <h5>Asignación de Activos</h5>
                  </div>
                </div>
                <div className="row m-5 justify-content-center">
                  <div className='col-6'>
                    <h6>Portafolio Cliente</h6>
                    <PiePlot 
                      data={port_w}
                      legend={true}
                      percTooltip={true}
                      legendHeight={150}
                      width={550}
                      height={500}
                      outerRadius={100}
                      dataKey="w"
                      nameKey="name"
                    />
                  </div>
                  <div className='col-6'>
                    <h6>Portafolio Recomendado</h6>
                    <PiePlot 
                      data={bench_w}
                      legend={true}
                      percTooltip={true}
                      legendHeight={150}
                      width={550}
                      height={500}
                      outerRadius={100}
                      dataKey="w"
                      nameKey="name"
                    />
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className='col'>
                    <hr></hr>
                  </div>
                </div>
              </Collapse>
            </>
            :null
            }
            {real_rets!=null 
            ? <>
                <div className="row m-5 justify-content-center">
                  <div className='col' id="real_rets">
                    <h5><b>Retornos Realizados ({this.props.client_params.risk_type})</b></h5>
                    <a className='linkcol' href='#exp'>exposición&darr;</a>
                    <a className='linkcol' href='#risk'>{'  '}riesgo-retorno&darr;</a>
                    <a className='linkcol' href='#perf'>{'  '}desempeño&darr;</a>
                  </div>
                </div>
                <div className="row m-4 justify-content-center align-items-start">
                  <div className='col-md-6'>
                    <div className="row justify-content-center">
                      <div className='col-auto'>
                        <RenderVirtualTable 
                          data={real_rets} 
                          to_perc={[false, true, true]}
                          cell_width={["100px", '100px', '100px']}
                          item_size={30}
                          style="black"
                          />

                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    {this.props.client_port_metrics.names.length>1
                    ? <MultBarPlot 
                        data={real_rets}
                        nameKey='Periodo'
                        vertical={true}
                        angle={0}
                        ytype="category" xtype="number"
                        colors={["#000000", "#2803fc"]}
                        xpercAxis={true}
                        percTooltip={false}
                        width={500}
                        ml={100}
                        interval={0}
                        height={400}
                        barsize={10}
                        legend={true}
                      />
                    : <BarPlot 
                        y={real_rets.map(x=>x.Periodo)}
                        x={real_rets.map(x=>x.Portafolio)}
                        layout="vertical"
                        angle={0}
                        ytype="category" xtype="number"
                        color="#000000"
                        xpercAxis={true}
                        moneyTooltip={true}
                        width={500}
                        ml={100}
                        interval={0}
                        height={400}
                        barsize={10}
                      />
                    }
                  </div>
                </div>
              </>
            : <div className='row m-5'>
                <div className='col m-5'>
                  <h6>No hay datos disponibles.</h6>
                </div>
              </div>
            }
            {/*Exposición*/}
            {port_assetclass_exp!==null ?
            <>
              <div className="row m-4 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>
              <div className="row m-4 justify-content-center">
                <div className='col' id="exp">
                  <h5><b>Exposición</b></h5>
                  <a className='linkcol' href='#real_rets'>retornos realizados&uarr;</a>
                  <a className='linkcol' href='#risk'>{'  '}riesgo-retorno&darr;</a>
                  <a className='linkcol' href='#perf'>{'  '}desempeño&darr;</a>
                </div>
              </div>
              <div className="row mt-4 justify-content-center">
                <div className='col-md-6'>
                  <h6>Clase de Activo</h6>
                    <MultBarPlot 
                      data={port_assetclass_exp}
                      nameKey='AssetClass'
                      vertical={true}
                      angle={0}
                      ytype="category" xtype="number"
                      colors={["#000000", "#2803fc"]}
                      xpercAxis={true}
                      moneyTooltip={false}
                      width={500}
                      ml={120}
                      interval={0}
                      height={400}
                      barsize={10}
                      legend={true}
                      fontsize={13}
                    />
                </div>
                <div className='col-md-6'>
                  <h6>Moneda</h6>
                  <MultBarPlot 
                    data={port_curr_exp}
                    nameKey='Currency'
                    vertical={true}
                    angle={0}
                    ytype="category" xtype="number"
                    colors={["#000000", "#2803fc"]}
                    xpercAxis={true}
                    moneyTooltip={false}
                    width={500}
                    ml={100}
                    interval={0}
                    height={400}
                    barsize={10}
                    legend={true}
                    fontsize={13}
                  />
  
                </div>
              </div>
              {/*
              <div className='row'>
                <div className='col'>
                  <CSVLink className='link-btn' data={[...port_assetclass_exp.map(x=>{return {...x, variable:"Clase de Activo"}}), ...port_curr_exp.map(x=>{return {...x, variable:"Moneda"}})]} filename="portfolio"><small>Descargar exposición &darr;</small></CSVLink>
                </div>
              </div>
              */
              }
            </>
            :null
            }
            {series!=null 
            ? <>
              <div className="row m-4 justify-content-center">
                <div className='col'>
                  <hr></hr>
                </div>
              </div>  
              <div className="row m-4 justify-content-center">
                <div className='col' id="risk">
                  <h5><b>Riesgo - Retorno ({this.props.client_params.risk_type})</b></h5>
                  <a className='linkcol' href='#real_rets'>retornos realizados&uarr;</a>
                  <a className='linkcol' href='#exp'>{'  '}exposición&uarr;</a>
                  <a className='linkcol' href='#perf'>{'  '}desempeño&darr;</a>
                </div>
              </div>
              <div className="row m-5 justify-content-center align-items-start">
                <div className='col-md-6'>
                  <div className="row justify-content-center align-items-center">
                    <div className='col-auto'>
                      <RenderVirtualTable 
                        data={rets_summ} 
                        to_perc={[false, true, true]}
                        to_perc_row={[true, true, true, true, false, true, false, false, false]}
                        cell_width={['200px', "100px", '100px']}
                        item_size={30}
                        style="black"
                        />
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <MultLineTsPlot data={series}
                   width={500}
                   xkey='Date'
                   ykeys={this.props.client_port_metrics.names}
                   xtype='category'
                   ytype='number'
                   colors = {['#000000', "#2803fc"]}
                   percTooltip={false}
                   legend={true ? this.props.client_port_metrics.names.length > 1 : false}
                   ml={50}
                  />
                </div>
              </div>
              <div className='row justify-content-center'>
                <div className='col-auto'>
                  <CSVLink className='link-btn' data={rets_summ} filename="metrics"><small>Descargar métricas &darr;</small></CSVLink>
                </div>
                <div className='col-auto'>
                  <CSVLink className='link-btn' data={series} filename="series"><small>Descargar series &darr;</small></CSVLink>
                </div>
              </div>
              </>
            : <></>
            }
            <div className="row m-4 justify-content-center">
              <div className='col'>
                <hr></hr>
              </div>
            </div>
            <div className="row m-4 justify-content-center">
              <div className='col' id="perf">
                <h5><b>Desempeño</b></h5>
                <a className='linkcol' href='#real_rets'>retornos realizados&uarr;</a>
                <a className='linkcol' href='#exp'>{'  '}exposición&uarr;</a>
                <a className='linkcol' href='#risk'>{'  '}riesgo-retorno&uarr;</a>
              </div>
            </div>
            <div className="row mt-4 justify-content-center">
              <div className="col-6 m-3">
                <Alert
                  color={this.state.msg_backtest!==null && this.state.msg_backtest.includes('Error') ? 'danger':'secondary'}
                  isOpen={this.state.msg_backtest!=='' && this.state.msg_backtest!==null} 
                  toggle={()=>this.setState({msg_backtest:null})}>
                    {this.state.msg_backtest}
                </Alert>
              </div>
            </div>
            {this.state.loading_backtest ?
              <div className="row justify-content-center m-5">
                <CustomLoading msg="backtesting" icon="fa-calculator"/>
              </div>
            : this.props.client_port_backtest!==null && this.props.client_port_backtest.status=="ok"
            ? <>
                <div className="row m-2 justify-content-center">
                  <div className='col' id="contrib">
                    <h5>Análisis de Contribución</h5>
                    <a className='linkcol' href='#attrib'>atribución&darr;</a>
                  </div>
                </div>
                <div className="row m-5 justify-content-center">
                  <div className='col-9'>
                    <h6>Retorno Total</h6>
                  </div>
                </div>
                <div className={`row mt-4 ${this.props.client_port_backtest.tr_contrib.filter(item=>item.Portafolio>0).length>10 ? 'align-items-center':'align-items-start'}`}>
                  <div className='col-md-6'>
                    <div className='row justify-content-center'>
                      <div className='col-7'>
                        <RenderVirtualTable 
                          data={this.props.client_port_backtest.tr_contrib.filter(item=>item.Portafolio>0).map(item=>{
                            return {Activo:item.Activo, Portafolio:item.Portafolio};
                          })} 
                          to_perc={[false, true, true]}
                          cell_width={['200px', '100px', '100px']}
                          item_size={30}
                          />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <MultBarPlot 
                      data={this.props.client_port_backtest.tr_contrib.filter(item=>item.Portafolio>0).map(item=>{
                        return {Activo:item.Activo, Portafolio:item.Portafolio};
                      })} 
                      nameKey='Activo'
                      vertical={true}
                      angle={0}
                      ytype="category" xtype="number"
                      colors={["#000000", "#2803fc"]}
                      xpercAxis={true}
                      percTooltip={true}
                      width={500}
                      interval={0}
                      height={400}
                      barsize={10}
                      top={0}
                      fontsize={12}
                    />
                  </div>
                </div>
                <div className='row mt-3 justify-content-center'>
                  <div className='col-10'>
                    <CSVLink className='link-btn' data={this.props.client_port_backtest.tr_contrib} filename="metrics"><small>Descargar contribución de retorno&darr;</small></CSVLink>
                  </div>
                </div>
                <div className="row m-5 justify-content-center">
                  <div className='col'>
                    <h6>Riesgo</h6>
                  </div>
                </div>
                <div className={`row mt-4 ${this.props.client_port_backtest.risk_contrib.length>10 ? 'align-items-center':'align-items-start'}`}>
                  <div className='col-md-6'>
                    <div className='row justify-content-center'>
                      <div className='col-9'>
                        <RenderVirtualTable 
                          data={this.props.client_port_backtest.risk_contrib.map(item=>{
                            return {"Activo":item.Activo, "Contribución Vol.": item["Contribución Vol."], "Contribución Vol. %":item["Contribución Vol. %"]}
                          })} 
                          to_perc={[false, true, true]}
                          cell_width={['200px', '100px', '100px']}
                          item_size={30}
                          />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6 mt-2'>
                    <MultBarPlot 
                      data={this.props.client_port_backtest.risk_contrib.map(item=>{
                        return {'Activo':item.Activo, 'Contribución Vol.':item['Contribución Vol.']}
                      })}
                      nameKey='Activo'
                      vertical={true}
                      angle={0}
                      ytype="category" xtype="number"
                      colors={["#000000", "#9EA2A2"]}
                      xpercAxis={true}
                      percTooltip={true}
                      width={500}
                      interval={0}
                      height={400}
                      barsize={8}
                      top={0}
                      legent={false}
                      fontsize={12}
                    />
                  </div>
                </div>
                  <div className='row mt-3'>
                    <div className='col'>
                      <CSVLink className='link-btn' data={this.props.client_port_backtest.risk_contrib} filename="metrics"><small>Descargar contribución de riesgo &darr;</small></CSVLink>
                    </div>
                  </div>
                <div className="row m-4 justify-content-center">
                  <div className='col'>
                    <hr></hr>
                  </div>
                </div>
                <div className="row m-5 justify-content-center">
                  <div className='col' id="attrib">
                    <h5>Análisis de Atribución</h5>
                    <a className='linkcol' href='#contrib'>contribución&uarr;</a>

                  </div>
                </div>
                <div className='row m-4 justify-content-center'>
                  <div className='col-2'>
                    <Label check>
                      <Input type="checkbox"
                        checked={this.state.tra_agg}
                        onChange={()=>this.setState({tra_agg:!this.state.tra_agg})}
                        />
                        <small>{'   '}Clase de Activo</small>
                    </Label>
                  </div>
                </div>
                <div className={`row mt-4 ${tra_asset.length>10 ? 'align-items-center':'align-items-start'}`}>
                  <div className='col-md-6'>
                    <div className='row justify-content-center'>
                      <div className='col-12'>
                        <RenderVirtualTable 
                          data={tra_asset} 
                          to_perc={[false].concat(new Array(10).fill(true))}
                          cell_width={['150px', '65px', '65px', '65px'].concat(new Array(10).fill('60px'))}
                          item_size={30}
                          fontsize={11}
                          />
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <MultBarPlot 
                      data={tra_asset.map(item=>{
                        return {'Key':this.state.tra_agg ? item['Clase de Activo'] : item.Activo, Total:item.Total}
                      })}
                      nameKey='Key'
                      vertical={true}
                      angle={0}
                      ytype="category" xtype="number"
                      colors={["#000000", "#9EA2A2"]}
                      xpercAxis={true}
                      percTooltip={true}
                      width={500}
                      interval={0}
                      height={Math.min(50*tra_asset.length, 550)}
                      barsize={8}
                      top={35}
                      legent={false}
                      fontsize={12}
                    />
                  </div>
                </div>
                <div className='row mt-3'>
                  <div className='col'>
                    <CSVLink className='link-btn' data={this.props.client_port_backtest.tra_asset} filename="metrics"><small>Descargar atribución de retorno &darr;</small></CSVLink>
                  </div>
                </div>
              </>
            : 
              <div className="row justify-content-center m-5">
                <h6>No hay datos disponibles.</h6>
              </div>
            }
          </div>
        );
      }
    }
}
//export default Port;
export default withRouter(connect(mapStateToProps)(ClientPortSuitability));